import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import _ from 'lodash';
import { ModalContext } from 'App';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import AddressRemove from 'modules/common/address/AddressRemove';
import { customStyle } from 'helper';
import * as actions from '../../../action';
import * as c from '../../../constant';

function TransferDetails({
  formData,
  setFormData,
  validateForm,
  inquireMachineryApplication,
  getBarangayList,
  barangayList,
  getDistrictList,
  districtList,
  getMachineryOwnerList,
  ownerList,
  createRichTextEditor,
  transactionCode,
}) {
  const setModal = useContext(ModalContext);

  const barangayOptions = barangayList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const districtOptions = districtList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const ownerOptions = ownerList.map((x) => ({
    label: _.get(x, 'attributes.full_name'),
    value: x.id,
    id: x.id,
  }));

  const closeModal = (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to cancel adding this record? Changes won`t be saved.',
      () => {
        setModal({ isOpen: false });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const onChangeTaxPayerAddress = (e) => {
    setFormData({
      ...formData,
      property_region_id: e.target.value.region_code,
      property_province_id: e.target.value.province_code,
    });
  };
  const handleOnSearch = () => {
    inquireMachineryApplication(
      {
        tdn: formData.tdn,
        rptax_transaction_code_id: transactionCode,
      },
      (res) => {
        const district = res?.data?.included?.buildingApplication
          ? res?.data?.included?.buildingApplication?.attributes
              ?.property_district_id
          : res?.data?.included?.landApplication?.attributes
              ?.property_district_id;
        setFormData({
          ...formData,
          pin: res?.data?.attributes?.pin ?? '',
          beneficial_user_id: res?.data?.included?.beneficialUser?.id ?? '',
          machinery_owner_name:
            res?.data?.included?.machineryOwner?.attributes?.full_name ?? '',
          land_application_id: res?.data?.included?.landApplication?.id ?? '',
          building_application_id:
            res?.data?.included?.buildingApplication?.id ?? '',
          rptax_building_owner_id:
            res?.data?.included?.buildingOwner?.id ?? null,
          property_barangay_id: res?.data?.included?.buildingApplication
            ? res?.data?.included?.buildingApplication?.attributes
                ?.property_barangay_id
            : res?.data?.included?.landApplication?.attributes
                ?.property_barangay_id,
          property_district_id: district,
          property_street: res?.data?.included?.buildingApplication
            ? res?.data?.included?.buildingApplication?.attributes
                ?.property_street
            : res?.data?.included?.landApplication?.attributes?.property_street,
          appraised_assessed_at:
            res?.data?.attributes?.appraised_assessed_at ?? '',
          appraised_assessed_by_id:
            res?.data?.attributes?.appraised_assessed_by_id ?? '',
          approved_at: res?.data?.attributes?.approved_at ?? '',
          approved_by_id: res?.data?.attributes?.approved_by_id ?? '',
          effectivity_of_assessment_reassessment_qtr:
            res?.data?.attributes?.effectivity_of_assessment_reassessment_qtr ??
            '',
          effectivity_of_assessment_reassessment_yr:
            res?.data?.attributes?.effectivity_of_assessment_reassessment_yr ??
            '',
          recommending_at: res?.data?.attributes?.recommending_at ?? '',
          recommending_by_id: res?.data?.attributes?.recommending_by_id ?? '',
          registered: res?.data?.attributes?.registered ?? '',
          machinery_application_id: res?.data?.id ?? '',
        });
        getBarangayList({
          rptax_district_id: district,
        });
      }
    );
  };
  const handleOnSelectMachineOwner = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  useEffect(() => {
    getDistrictList({
      province_id: 65,
    });
  }, []);

  useEffect(() => {
    getMachineryOwnerList();
  }, []);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <>
      <div className="row">
        <div className="col-12 mb-2">
          <div className="header-modal">Property To Transfer</div>
        </div>
        <div className="col-6 form-group pr-0">
          <label htmlFor="tdn" className="form-label mb-0">
            TDN/ARP No.
            {validateForm.renderMessage('tdn')}
          </label>
          <div
            className="input-group mb-3 col-12 mt-2 pr-0 w-100"
            style={{ marginLeft: -15 }}
          >
            <InputMask
              className="form-control"
              mask="aa-99999-99999"
              alwaysShowMask
              type="text"
              name="tdn"
              onChange={handleOnChange}
              value={_.get(formData, 'tdn') ?? ''}
            />
            <div className="input-group-append">
              <button
                disabled={
                  _.get(formData, 'tdn') === '__-_____-_____' ||
                  _.get(formData, 'tdn') === ''
                }
                type="button"
                onClick={handleOnSearch}
                className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
              >
                <span className="icon">
                  <i className="fa fa-lg fa-search" />
                </span>
              </button>
            </div>
          </div>
        </div>
        <div className="col-6 form-group pl-1">
          <label htmlFor="pin" className="form-label">
            PIN.
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="pin"
            onChange={handleOnChange}
            value={_.get(formData, 'pin') || ''}
          />
        </div>
        <div className="col-6 form-group pr-1">
          <label htmlFor="machinery_owner_name" className="form-label mb-0">
            Owner
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="machinery_owner_name"
            onChange={handleOnChange}
            value={_.get(formData, 'machinery_owner_name') || ''}
          />
        </div>
        <div className="col-6 form-group" />
        <div className="col-12 mb-2">
          <div className="header-modal">Property Location</div>
        </div>
        <div className="col-12 form-group">
          <AddressRemove
            required
            value={{
              region_code: _.get(formData, 'property_region_id') || '',
              province_code: _.get(formData, 'property_province_id') || '',
            }}
            onChange={onChangeTaxPayerAddress}
            region_name="property_region_id"
            province_name="property_province_id"
            name="tax_payer_address"
            withStreet={false}
            removeLabel
            isDisabled
          />
        </div>
        <div className="col-6 form-group pr-1">
          <label htmlFor="property_district_id" className="form-label mb-0">
            District
          </label>
          <Select
            options={districtOptions}
            isDisabled
            styles={customStyle}
            placeholder="Select District"
            value={
              districtOptions.filter(
                (item) =>
                  +_.get(formData, 'property_district_id') ===
                  +_.get(item, 'id')
              ) || ''
            }
            onChange={() => {}}
          />
        </div>
        <div className="col-6 form-group px-1">
          <label htmlFor="property_barangay_id" className="form-label mb-0">
            Barangay
          </label>
          <Select
            isDisabled
            options={barangayOptions}
            styles={customStyle}
            placeholder="Select Barangay"
            value={
              barangayOptions.filter(
                (item) =>
                  +_.get(formData, 'property_barangay_id') ===
                  +_.get(item, 'id')
              ) || ''
            }
            onChange={() => {}}
          />
        </div>
        <div className="col-12 form-group">
          <label htmlFor="property_street" className="form-label mb-0">
            Unit No. / House No. / Street Name{' '}
            {validateForm.renderMessage('property_street')}
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            name="property_street"
            onChange={() => {}}
            value={_.get(formData, 'property_street') || ''}
            readOnly
          />
        </div>
        <div className="col-6" />
        <div className="col-12 mb-2">
          <div className="header-modal">Transfer to</div>
        </div>
        <div className="col-6 form-group pr-1">
          <label htmlFor="rptax_machinery_owner_id" className="form-label">
            Owner: &nbsp;{' '}
            {validateForm.renderMessage('rptax_machinery_owner_id')}
          </label>
          <div>
            <Select
              options={ownerOptions}
              placeholder="-Select-"
              value={
                ownerOptions.filter(
                  (item) =>
                    +_.get(formData, 'rptax_machinery_owner_id') ===
                    +_.get(item, 'id')
                ) || ''
              }
              onChange={handleOnSelectMachineOwner('rptax_machinery_owner_id')}
            />
          </div>
        </div>
        <div className="col-12 form-group">
          {createRichTextEditor(
            { key: 'memoranda', label: 'Memoranda:' },
            { minLength: 3, required: true }
          )}
        </div>
      </div>
      <hr className="below-hr" style={{ marginTop: 55 }} />
      <div className="py-1">
        <div className="py-1">
          <div className="col-12 d-flex justify-content-center mt-3">
            <button
              type="button"
              onClick={closeModal}
              className="btn btn-light button-cancel-2 mr-1"
              style={{ backgroundColor: '#323943', color: '#fff' }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-light button-proceed ml-1 cms-bg-color-primary text-light"
              disabled={!validateForm.response.is_passed}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

TransferDetails.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  validateForm: PropTypes.instanceOf(Object).isRequired,
  inquireMachineryApplication: PropTypes.instanceOf(Function).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  districtList: PropTypes.instanceOf(Array).isRequired,
  getMachineryOwnerList: PropTypes.instanceOf(Function).isRequired,
  ownerList: PropTypes.instanceOf(Array).isRequired,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  transactionCode: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  districtList: _.get(api, `${c.GET_DISTRICTS_LIST}.list`) || [],
  ownerList: _.get(api, `${c.GET_MACHINERY_OWNER}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(TransferDetails);
